import { Alert, Box, Button, Dialog, DialogContent, IconButton, Snackbar, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store";
import { Transition } from "../../hooks/useConfirm";
import { Calendar2Icon, CrossIcon } from "../../assets/icons";
import { Fragment, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { checkEmpty } from "../../utils";
import moment from "moment";
import { useTranslation } from "react-i18next";

export default function SubscriptionBanner() {
  const { t, i18n } = useTranslation('subscriptionBanner');
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [subscriptionMessage, setSubscriptionMessage] = useState<string>();
  const subscriptionCheck = useSelector((state: RootState) => state.global.subscriptionCheck);

  const handleClose = (event: React.SyntheticEvent | Event, reason?: string) => {
    setOpen(false);
  };

  useEffect(() => {
    if (subscriptionCheck?.id) {
      const dayCount = moment(subscriptionCheck.lastShipment, "MMMM D, YYYY").diff(moment().startOf("day"), "days");
      if (subscriptionCheck.oneDay) {
        const oneDayStorage = localStorage.getItem("oneDayReminder");
        if (!oneDayStorage) {
          localStorage.setItem("oneDayReminder", "1");
          setOpen(true);
          setSubscriptionMessage(dayCount.toString());
        }
      } else if (subscriptionCheck.threeDays) {
        const threeDaysStorage = localStorage.getItem("threeDaysReminder");
        if (!threeDaysStorage) {
          localStorage.setItem("threeDaysReminder", "1");
          setOpen(true);
          setSubscriptionMessage(dayCount.toString());
        }
      } else if (subscriptionCheck.sevenDays) {
        const sevenDaysStorage = localStorage.getItem("sevenDaysReminder");
        if (!sevenDaysStorage) {
          localStorage.setItem("sevenDaysReminder", "1");
          setOpen(true);
          setSubscriptionMessage(dayCount.toString());
        }
      }
      localStorage.setItem("activeSubscriptionToRenew", String(subscriptionCheck.id));
    }
  }, [subscriptionCheck]);

  return (
    <Dialog
      sx={{
        "& .MuiPaper-root": {
          borderRadius: "16px",
          // boxShadow: "0px 12px 24px 0px rgba(0, 0, 0, 0.15)",
          padding: "8px",
          width: "100%",
          // height: "100%",
          // margin: "4px",
          // maxHeight: "calc(100% - 8px)",
        },
        "& .MuiDialogContent-root,& .MuiDialogActions-root": {
          padding: "20px 24px",
        },
        "& .MuiDialogContent-root": {
          color: "text.fontDarkest",
          textAlign: "center",
          fontSize: "14px",
          width: "100%",
          display: "flex",
        },
      }}
      open={open}
      TransitionComponent={Transition}
      onClose={handleClose}
    >
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: "text.fontDarkest",
        }}
      >
        <CrossIcon />
      </IconButton>
      <DialogContent>
        <Box sx={{ display: "flex", flexDirection: "column", gap: "16px" }}>
          <Typography
            sx={{
              fontSize: "16px",
              fontWeight: 700,
              lineHeight: "22px",
              color: "text.errorDefault",
              marginTop: "16px",
            }}
          >
            {t("planAlmostOver")}
          </Typography>
          <Box sx={{ fontSize: "14px", lineHeight: "22px", color: "text.fontDefault" }}>
            {t("daysLeft")
              .split("{days}")[0]}
            <Typography component={"span"} sx={{ fontWeight: 700, color: "text.fontDefault" }}>
              {subscriptionMessage}
            </Typography>
            {t("daysLeft")
              .split("{days}")[1]}
          </Box>
          <Box sx={{ display: "flex", gap: "4px", color: "text.fontDefault", justifyContent: "center" }}>
            <Calendar2Icon />
            <Typography sx={{ fontWeight: 600, lineHeight: "22px", fontSize: "14px" }}>
              {t("lastShipment").replace("{date}", subscriptionCheck?.lastShipment || "")}
            </Typography>
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
            {subscriptionCheck?.planOptionFound ? (
              <Fragment>
                <Link
                  to={String(subscriptionCheck?.url)}
                  onClick={() => {
                    setOpen(false);
                  }}
                >
                  <Button
                    sx={{ borderRadius: "12px", fontWeight: 500, fontSize: "14px", padding: "12px 16px" }}
                    fullWidth
                    color="primary"
                    variant="contained"
                    disableElevation
                  >
                    {t("renewExistingPlan")}
                  </Button>
                </Link>

                <Link
                  to={`${String(subscriptionCheck?.planUrl)}/meal-selection`}
                  onClick={() => {
                    setOpen(false);
                  }}
                >
                  <Button
                    sx={{ borderRadius: "12px", fontWeight: 500, fontSize: "14px", padding: "12px 16px" }}
                    fullWidth
                    color="primary"
                    variant="outlined"
                    disableElevation
                  >
                    {t("selectNewPlan")}
                  </Button>
                </Link>
              </Fragment>
            ) : (
              <Link to={`${subscriptionCheck?.url}`} onClick={() => setOpen(false)}>
                <Button
                  sx={{ borderRadius: "12px", fontWeight: 500, fontSize: "14px", padding: "12px 16px" }}
                  fullWidth
                  color="primary"
                  variant="outlined"
                  disableElevation
                >
                  {t("SubscriptionBanner.selectNewPlan")}
                </Button>
              </Link>
            )}
          </Box>
          <Typography sx={{ fontSize: "12px", lineHeight: "16px", color: "text.fontLight" }}>
            {t("footnote")}
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
